import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import CustomConstants from './collection/derived-constants/CustomConstants';
import CustomLoader from '../common/CustomLoader';
import CollectionHeaderNav from './CollectionHeaderNav';
import types from '../../common/formElements/CollectionSectionType';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { CONSTANT } from 'drapcode-constant';
export class Constants extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, collectionId, version } = match.params;
    actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    actions.getPermissionFlags({ projectId });
    commonActions.loadCollectionChange();
  }

  render() {
    const { collections, match, actions, common, commonActions } = this.props;
    const { projectId, collectionId, version } = match.params;
    const {
      loadProjectCollectionDetailPending,
      createCollectionConstantPending,
      updateConstantOfCollectionPending,
      selectedCollection,
      deleteCollectionConstantPending,
      permissionFlags,
    } = collections;
    const { updatedCollections } = common;
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    const showDerivedConstantLoader =
      createCollectionConstantPending || updateConstantOfCollectionPending;
    return (
      <CommonPageComponent parentClassName="">
        <CollectionHeaderNav
          label={types.CONSTANT}
          projectId={projectId}
          version={version}
          selectedCollection={selectedCollection}
          loadProjectCollectionDetailPending={loadProjectCollectionDetailPending}
        />
        {loadProjectCollectionDetailPending && (
          <div className="text-center">
            <CustomLoader
              loading={loadProjectCollectionDetailPending}
              size="20px"
              color="#303453"
            />
          </div>
        )}
        {selectedCollection && (
          <CustomConstants
            actions={actions}
            commonActions={commonActions}
            projectId={projectId}
            version={version}
            constants={selectedCollection.constants}
            collection={selectedCollection}
            showDerivedConstantLoader={showDerivedConstantLoader}
            showConstantDeleteLoader={deleteCollectionConstantPending}
            deleteFlag={permissionsArray.includes(CONSTANT)}
            updatedCollections={updatedCollections}
          />
        )}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    commonActions: bindActionCreators({ ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Constants);
